import type { ComponentType } from 'react';
import React from 'react';

import type { EditorActions } from '@atlaskit/editor-core';
import { WithEditorActions } from '@atlaskit/editor-core';
import { EditorContext } from '@atlaskit/editor-core/editor-context';

type WithEditorActionsProps = {
	editorActions: EditorActions;
};

export function withEditorActions<T>(WrappedComponent: ComponentType<T>) {
	return function withEditorActions(props: Omit<T, keyof WithEditorActionsProps>) {
		return (
			<EditorContext>
				<WithEditorActions
					render={(editorActions: EditorActions) => (
						<WrappedComponent {...(props as T)} editorActions={editorActions} />
					)}
				/>
			</EditorContext>
		);
	};
}
